import { CURRENCIES, DOC_TYPES, TAX_MODES } from "@/lib/invoice/utils";

export const currencyOptions = Object.entries(CURRENCIES).map(([k, v]) => ({ value: k, label: `${k} – ${v.label}` }));
export const taxModeOptions = Object.entries(TAX_MODES).map(([k, v]) => ({ value: k, label: v.label }));
export const docTypeOptions = Object.entries(DOC_TYPES).map(([k, v]) => ({ value: k, label: v.label }));

export const INDIAN_STATES = [
  ["01", "Jammu & Kashmir"], ["02", "Himachal Pradesh"], ["03", "Punjab"], ["04", "Chandigarh"], ["05", "Uttarakhand"],
  ["06", "Haryana"], ["07", "Delhi"], ["08", "Rajasthan"], ["09", "Uttar Pradesh"], ["10", "Bihar"], ["11", "Sikkim"],
  ["12", "Arunachal Pradesh"], ["13", "Nagaland"], ["14", "Manipur"], ["15", "Mizoram"], ["16", "Tripura"],
  ["17", "Meghalaya"], ["18", "Assam"], ["19", "West Bengal"], ["20", "Jharkhand"], ["21", "Odisha"],
  ["22", "Chhattisgarh"], ["23", "Madhya Pradesh"], ["24", "Gujarat"], ["26", "Dadra & Nagar Haveli and Daman & Diu"],
  ["27", "Maharashtra"], ["29", "Karnataka"], ["30", "Goa"], ["31", "Lakshadweep"], ["32", "Kerala"],
  ["33", "Tamil Nadu"], ["34", "Puducherry"], ["35", "Andaman & Nicobar"], ["36", "Telangana"], ["37", "Andhra Pradesh"],
  ["38", "Ladakh"],
];

const stateNorm = (s) => String(s || "").toLowerCase().replace(/&/g, "and").replace(/\s+/g, " ").trim();
export const stateCode = (name) => INDIAN_STATES.find(([, n]) => stateNorm(n) === stateNorm(name))?.[0];

export const BILLING_OPTIONS = [
  { value: "monthly", label: "Monthly retainer" },
  { value: "one-time", label: "One-time / fixed" },
  { value: "hourly", label: "Hourly" },
];

export const PROJECT_STATUS = [
  { value: "active", label: "Active" },
  { value: "paused", label: "Paused" },
  { value: "completed", label: "Completed" },
];
